import { useEffect, useState } from "react";
import "./Register.scss";
import { login, register } from "../../services/auth";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

export default function Register({ setOpenLogin, setOpenRegister, user }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [cookie, setCookie] = useCookies(["access_token"]);

  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");

  const [policyAccept, setPolicyAccept] = useState(false);
  const [termsAccept, setTermsAccept] = useState(false);

  const [policyError, setPolicyError] = useState(false);
  const [termsError, setTermsError] = useState(false);

  const [nameError, setNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [invalidEmailError, setInvalidEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [invalidPhoneError, setInvalidPhoneError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [passwordMatchError, setPasswordMatchError] = useState(false);

  const [response, setResponse] = useState();
  const [newResponse, setNewResponse] = useState();
  const [showSuccess, setShowSuccess] = useState(false);

  const validatePhoneNumber = (phoneNumber) => {
    const regex = /^(?:\+359|0)\d{9}$/;
    return regex.test(phoneNumber);
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleContinue = () => {
    if (!validatePhoneNumber(phone)) {
      setPhoneError(true);
      setInvalidPhoneError(true);
    } else {
      phoneError && setPhoneError(false);
      invalidPhoneError && setInvalidPhoneError(false);
    }

    if (!validateEmail(email)) {
      setEmailError(true);
      setInvalidEmailError(true);
    } else {
      emailError && setEmailError(false);
      invalidEmailError && setInvalidEmailError(false);
    }

    !email && setEmailError(true);
    !name && setNameError(true);
    !lastName && setLastNameError(true);
    !password && setPasswordError(true);
    !phone && setPhoneError(true);
    !policyAccept && setPolicyError(true);
    !termsAccept && setTermsError(true);

    !(password === repeatPassword) && setPasswordMatchError(true);

    if (
      name &&
      lastName &&
      email &&
      phone &&
      password &&
      policyAccept &&
      termsAccept &&
      !passwordMatchError &&
      !phoneError
    ) {
      handleUpload();
    }
  };

  const handleUpload = () => {
    if (name && lastName && email && phone && password) {
      register(name, lastName, email, password, phone).then((res) => {
        setResponse(res);
      });
    }
  };

  useEffect(() => {
    if (response?.status === 201) {
      setShowSuccess(true);
    } else {
      if (response?.data?.message === "EMAIL_TAKEN_ERROR") {
        setInvalidEmailError(true);
      }
      if (response?.data?.message === "PHONE_TAKEN_ERROR") {
        setInvalidPhoneError(true);
      }
    }
  }, [response]);

  useEffect(() => {
    password === repeatPassword
      ? setPasswordMatchError(false)
      : setPasswordMatchError(true);
  }, [password, repeatPassword]);

  const autoLogin = () => {
    login(email, password).then((res) => setNewResponse(res));
  };

  useEffect(() => {
    if (!user?.isGuest || showSuccess) {
      newResponse?.data?.access_token &&
        setCookie("access_token", newResponse?.data?.access_token, {
          path: "/",
        });

      if (cookie?.access_token) {
        setOpenRegister(false);
        setOpenLogin(false);
        setShowSuccess(false);
        navigate("/");
      }
    }
  }, [newResponse]);

  return (
    <div className="register-wrapper">
      <div className={"register-popup"}>
        <div className="register-header">
          <div className="back-button">
            <button
              onClick={() => {
                setOpenLogin(true);
                setOpenRegister(false);
              }}
            ></button>
          </div>
          <div className="title">
            <p>{t("register")}</p>
          </div>
          <div className="reg-close-button">
            <button
              onClick={() => {
                setOpenRegister(false);
              }}
            ></button>
          </div>
        </div>
        {/* {registerSteps === 1 ? ( */}
        <div className="form">
          <div className="input-fields">
            <div className="name">
              <input
                className={nameError && "error"}
                type="text"
                placeholder={`${t("name")}*`}
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              ></input>
            </div>
            <div className="name">
              <input
                className={lastNameError && "error"}
                type="text"
                placeholder={`${t("surname")}*`}
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
              ></input>
            </div>
            <div className="phone">
              <PhoneInput
                defaultCountry="BG"
                country="BG"
                value={phone}
                onChange={setPhone}
                placeholder={`${t("number")}*`}
              ></PhoneInput>
              {invalidPhoneError && (
                <p className="error-message">
                  Въведеният номер е невалиден или вече използван.
                </p>
              )}
            </div>
            <div className="email">
              <input
                className={emailError && "error"}
                type="email"
                placeholder={`${t("email")}*`}
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                onError={() => setInvalidEmailError(true)}
              ></input>
              {invalidEmailError && (
                <p className="error-message">
                  Въведеният имейл е невалиден или вече използван.
                </p>
              )}
            </div>
            <div className="password">
              <input
                className={passwordError && "error"}
                type="password"
                placeholder={`${t("password")}*`}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
            </div>
            <div className="password">
              <input
                className={passwordMatchError && "error"}
                type="password"
                placeholder={`${t("repeat-password")}*`}
                value={repeatPassword}
                onChange={(e) => {
                  setRepeatPassword(e.target.value);
                }}
              />
              {passwordMatchError && (
                <p className="error-message">Паролите не съвпадат</p>
              )}
            </div>
          </div>
          <div className="agreements">
            <div className="agree">
              <input
                type="checkbox"
                onClick={() => setPolicyAccept(!policyAccept)}
                checked={policyAccept}
              ></input>
              <label className={policyError && "error"}>
                {t("agree-policy")} <a>{t("privacy-policy")} </a>*
              </label>
            </div>
            <div className="agree">
              <input
                type="checkbox"
                onClick={() => setTermsAccept(!termsAccept)}
                checked={termsAccept}
              ></input>
              <label className={termsError && "error"}>
                {t("agree-terms")}  <a>{t("terms-and-conditions")} </a>*
              </label>
            </div>
          </div>
          <div className="buttons">
            <div className="salmon-button">
              <button
                onClick={() => {
                  handleContinue();
                }}
              >
                {t("continue")}
              </button>
            </div>
          </div>
        </div>
      </div>
      {showSuccess && (
        <div className="success">
          <div className="popup">
            <div className="image"></div>
            <div className="text">
              <div className="success-title">
                {t("registration-successful")}
              </div>
              <div className="success-subtitle">{t("see-menu")}</div>
            </div>
            <div className="buttons">
              <button
                className="fill"
                onClick={() => {
                  autoLogin();
                }}
              >
                {t("okay")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
